import Vue from 'vue'

export const browserCompatibility = {
    namespaced: true,
    state: {
        opened: false,
        allowClose: true,
        compatibilities: []
    },
    actions: {
        addCompatibility({ commit }, compatibility) {
            commit('addCompatibility', { compatibility });
        },
        open({ commit }, { allowClose }) {
            commit('open');
            if (allowClose !== undefined) {
                commit('setAllowClose', { allowClose });
            } else {
                // Default case
                commit('setAllowClose', { allowClose: true });
            }
        },
        close({ commit }) {
            commit('close');
        }
    },
    mutations: {
        addCompatibility(state, { compatibility }) {
            let existsCompatibility = state.compatibilities.find(c => c.titleTag === compatibility.titleTag) !== undefined;
            if (!existsCompatibility) {
                Vue.set(state, 'compatibilities', [...state.compatibilities, compatibility]);
            }
        },
        open(state) {
            Vue.set(state, 'opened', true);
        },
        close(state) {
            Vue.set(state, 'opened', false);
        },
        setAllowClose(state, { allowClose }) {
            Vue.set(state, 'allowClose', allowClose);
        }
    },
    getters: {
        getCompatibilities: state => state.compatibilities,
        getOpened: state => state.opened,
        getAllowClose: state => state.allowClose
    }
}